import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PsychologicalSurveyApiService } from '@app/core/service/api/psychologicalSurvey.api.service';
import { DirectivesModule } from '@app/modules/directives.module';
import { EmptyStubModule } from '@app/modules/empty-stub/empty-stub.module';
import { FullHeightContainerModule } from '@app/modules/full-height-container/full-height-container.module';
import { MoodCheckQuestionModule } from '@app/modules/mood-check-question/mood-check-question.module';
import { NegativeFeedbackQuestionModule } from '@app/modules/negative-feedback-question/negative-feedback-question.module';
import { PositiveFeedbackQuestionModule } from '@app/modules/positive-feedback-question/positive-feedback-question.module';
import { TeamEvaluationQuestionModule } from '@app/modules/team-evaluation-question/team-evaluation-question.module';
import { IonicModule } from '@ionic/angular';
import { PsychologicalSurveyModalComponent } from './psychological-survey-modal.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    DirectivesModule,
    EmptyStubModule,
    FormsModule,
    PositiveFeedbackQuestionModule,
    NegativeFeedbackQuestionModule,
    MoodCheckQuestionModule,
    TeamEvaluationQuestionModule,
    FullHeightContainerModule
  ],
  declarations: [PsychologicalSurveyModalComponent],
  providers: [PsychologicalSurveyApiService]
})
export class PsychologicalSurveyModalModule {}
